module.exports = __webpack_public_path__ + "img/clip_image002.d2469a9d.png";